export const FEEDBACK_TYPES = {
    None: "None",
    Success: "Success",
    Warning: "Warning",
    Error: "Error",
};
